module.exports = __webpack_public_path__ + "static/media/BrittanyGay-Resume-2021.8b72daad.pdf";